export default __webpack_public_path__ + "static/media/approved.5ffe542b.svg";